<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">About Us</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool02/1.jpeg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Contact us</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Name</h2>
                <p><b>Dean</b></p>
                <p><b>Email :deanresearch@arni.in</b></p>

                <h2 class="h1 mb-1-6 text-primary">Name</h2>
                <p><b>H.O.D</b></p>
                <p><b>Email :hodsom@arni.in</b></p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
